import { USUARIO_AUTENTICADO, LOGIN_EXITOSO, CASO_BASE } from '../../types/index.js'

const authReducer = (state, action) => {
    switch (action.type) {

        case LOGIN_EXITOSO:
            localStorage.setItem("auth", JSON.stringify(action.payload));

            return {
                ...state,
                token: action.payload.token,
                autenticado: (action.payload.token ?? "").length > 0,
                usuario: action.payload.posName1,
                puntoVenta: action.payload.puntoVenta,
                es_pin: action.payload.es_pin,
                cambiar_pin: action.payload.cambiar_pin,
                uid: action.payload.uid,
                tiene_2fa: action.payload.tiene_2fa, 
                tipo_modelo: action.payload.tipo_modelo,
            }

        case USUARIO_AUTENTICADO:
            return {
                ...state,
                usuario: action.payload

            }

        case CASO_BASE:
            //Esta sección es para JS puro que no tiene que ver con el despligue de la información.

            return {
                ...state,
                token: action.payload
                // Código Personalizado
                // Con relación con el renderizado de información
            }

        default: return state;
    }
}

export default authReducer;
